import { useContext } from "react";
import { AlertContext } from "../providers/AlertProvider";

export default function useAlert() {
  const context = useContext(AlertContext);
  if (context === undefined) {
    throw new Error("useAlert must be used within a AlertProvider");
  }
  return context;
}
